import { Col, Card, Button, ListGroup, ProgressBar, Badge } from "react-bootstrap";
import Hints from "./Hints";

function FarmCards(props: any) {
    return (
        <Col md={6} xl={4}>
            <Card className="p-0 mb-4">
                
                {/* Card Header */}
                <Card.Header className="p-4 border-bottom">
                    <div className="d-flex justify-content-between aligh-items-center mb-4">
                       <div>
                            <Card.Title className="card-title fs-20 fw-700 mb-0">
                                {props.TokenName}
                            </Card.Title>
                            
                        </div>
                        <img
                            className="rounded"
                            src={props.srcImage}
                            width={50}
                            height={50}
                            alt={props.TokenName}
                        />
                        
                    </div>
                    {/* Progress Bar  */}
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center fw-500 mx-1 mb-2">
                            <div className="d-flex align-items-center">
                                APY
                                <Hints
                                    show="top"
                                    text={(
                                        <>
                                            APY is calculated when Harvest and Stake is made once in {props.DaysText} within a year
                                        </>
                                    )}
                                    content={(<i className="fa-regular fa-circle-question color-grey ms-2" />)}
                                />
                            </div>
                            <div className="ms-auto">
                                {props.APYPercent} 
                            </div>
                        </div>
                        <div className="d-flex align-items-center fw-500 mx-1 mb-2">
                            <div className="d-flex align-items-center">
                                Total Stake
                                <Hints
                                    show="top"
                                    text={(
                                        <>
                                            The total stake of tokens for all users in this pool
                                        </>
                                    )}
                                    content={(<i className="fa-regular fa-circle-question color-grey ms-2" />)}
                                />
                            </div>
                            <div className="ms-auto">
                                {props.TotalStakeProgess} 
                            </div>
                        </div>
                        <div className="d-flex align-items-center fw-500 mx-1 mb-2">
                            <div className="d-flex align-items-center">
                                Pending Reward
                                <Hints
                                    show="top"
                                    text={(
                                        <>
                                            The total pending reward that you can harvest now.
                                        </>
                                    )}
                                    content={(<i className="fa-regular fa-circle-question color-grey ms-2" />)}
                                />
                            </div>
                            <div className="ms-auto">
                                0 LeftyTears
                            </div>
                        </div>
                    </div>
                </Card.Header>
                {/* Card Body */}
                <Card.Body className="p-4">
                   
                    {/* List Box Two */}
                    <ListGroup className="list-unstyled bg-light p-3 rounded-8 mb-4">
                        <ListGroup.Item className="d-flex align-items-center mb-3">
                            <div className="d-flex align-items-center me-auto color-grey">
                                Earned LeftyTears
                                <Badge bg={props.StatusBg} className="ms-2 p-2">
                                    {props.StatusName}
                                </Badge>
                            </div>
                            <Button variant="green btn-sm py-2 px-3 disabled">
                                Harvest
                            </Button>
                        </ListGroup.Item>
                        <ListGroup.Item className="d-flex align-items-center">
                            <span className="me-auto color-grey">Overview</span>
                            <a href={props.ContractLink} className="link" target="_blank">
                                View contract
                                <i className="fa-regular fa-arrow-up-right-from-square ms-2" />
                            </a>
                        </ListGroup.Item>
                    </ListGroup>
                    {/* Button */}
                    <Button variant="primary d-flex align-items-center justify-content-center btn-sm w-100">
                        <img
                            className="rounded me-3"
                            src={props.srcImage}
                            width={24}
                            height={24}
                            style={{ outline: "2px solid var(--bg-primary)" }}
                        />
                        <span className="fs-16 fw-500">Approve {props.TokenName}</span>
                    </Button>
                    
                </Card.Body>
            </Card>
        </Col>
    );
}

export default FarmCards;